<template>
  <c-view>
    <c-page>
      <c-content class="page_content">
        <div class="img-box">
          <!-- <img src="../../assets/images/store-christmax/bg-coin.png"
               alt=""
               class="img-box"> -->
          <div class="img-bg-box">
            <div class="img1-box img-common">
              <span class="get-now"
                    v-if="ifGot"
                    @click="getCoupon">立即领取</span>
              <span class="get-now"
                    v-else>已经领取</span>
            </div>
            <div class="img2-box img-common">
              <a href="javascript:void(0);"
                 @click="buyPackageOne"
                 class="buy-package__one buy-btn__common"></a>
            </div>
            <div class="img3-box img-common">
              <a href="javascript:void(0);"
                 @click="buyPackageTwo"
                 class="buy-package__two buy-btn__common"></a>
            </div>
            <div class="img4-box img-common">
              <a href="javascript:void(0);"
                 @click="buyPackageThree"
                 class="buy-package__three buy-btn__common"></a>
              <a href="javascript:void(0);"
                 @click="buyWxCard"
                 class="buy-package__wxcard buy-btn__common"></a>
              <a href="javascript:void(0);"
                 @click="buyMiniProgram"
                 class="buy-package__miniprogram buy-btn__common"></a>
            </div>
            <!-- 旗舰版的话展示不同的价格 -->
            <div class="img5-box img-common">
              <a href="javascript:void(0);"
                 class="buy-btn__common buy-package__eye"
                 @click="buyPackageSmartEyes"></a>
            </div>
            <div class="img6-box img-common">
              <a href="javascript:void(0);"
                 class="buy-btn__common  buy-package__sms"
                 @click="buySms"></a>
            </div>
          </div>

        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
// @import 'swiper/dist/css/swiper.css';
@import './index';
</style>
<script>
import debounce from 'lodash.debounce'
import Vas from '@/model/value-added-service'
import Christmas from '@/model/christmas'
import api from '@/tools/api-tools'
import { mainWeb } from '@/config/net'
import Pay from '@/model/pay'
export default {
  data () {
    return {
      pay: new Pay(),
      christmas: new Christmas(),
      goodsId: '',
      version_params: {
        version: '',
        industryId: ''
      },
      ifGot: false, // false 未领取
      vasVersionInfo: new Vas()
    }
  },
  components: {},
  created () {
  },
  computed: {
  },
  methods: {
    buyPackageOne: debounce(async function () { // 购买第一个套餐，只有免费版用户可以购买
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      if (this.version_params.version >= 3) {
        // version < 3 是免费版
        this.$wejs.alert('此套餐为免费办专享,如有疑问，请联系客服：400-168-3399')
        return
      }
      this.goodsId = '194'
      this.pay.saasPay(this.goodsId, 1)
    }, 220),
    buyPackageTwo: debounce(async function () { // 购买一年套餐
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      if (this.version_params.version <= 3) {
        this.goodsId = '195'
        // 通用零售版以免费版
        this.pay.saasPay(this.goodsId, 1)
      }
      if (this.version_params.version.version >= 5) {
        var goodsId = this.getInIdFromGoodsId(this.version_params.industryId)
        // version >= 5 时版本
        this.pay.saasPay(goodsId, 1)
      }
    }, 220),
    buyPackageThree: debounce(async function () { // 购买买二送一
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      if (this.version_params.version <= 3) {
        this.goodsId = '206'
        // 通用零售版以免费版
        this.pay.saasPay(this.goodsId, 1)
      }
      if (this.version_params.version >= 5) {
        var goodsId = this.getGoodsDoubleIndustryId(this.version_params.industryId)
        // version >= 5 时版本
        this.pay.saasPay(goodsId, 1)
      }
    }, 220),
    buyWxCard: debounce(async function (id) {
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      this.goodsId = '204'
      this.pay.saasPay(this.goodsId, 1)
    }, 220),
    buyMiniProgram: debounce(async function (id) {
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      this.goodsId = '205'
      this.pay.saasPay(this.goodsId, 1)
    }, 220),
    buyPackageSmartEyes: debounce(async function (id) {
      // 121
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      // this.pay.saasPay(id, 1)
      this.$router.push({ path: '/hardwareMarket/detail/121' })
    }, 220),
    buySms: debounce(async function (id) {
      // api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=215`)
      this.$router.push({ path: '/recharge/message' })
    }, 220),
    getInIdFromGoodsId (id) { // 购买一年
      var goodsId = ''
      switch (Number(id)) {
        case 1:
          // 服装鞋帽
          goodsId = '196'
          break
        case 2:
          // 家电数码
          goodsId = '201'
          break
        case 7:
          // 母婴零售
          goodsId = '200'
          break
        case 8:
          // 眼镜
          goodsId = '199'
          break
        case 10:
          // 轻餐饮
          goodsId = '198'
          break
        case 11:
          // 美业
          goodsId = '197'
          break
        case 12:
          // 宠物
          goodsId = '202'
          break
        case 15:
          // 旗舰版
          goodsId = '203'
          break
      }
      return goodsId
    },
    getGoodsDoubleIndustryId (industryId) { // 购买买二赠一
      var goodsId = ''
      switch (Number(industryId)) {
        case 1:
          // 服装鞋帽
          goodsId = '207'
          break
        case 2:
          // 家电数码
          goodsId = '212'
          break
        case 7:
          // 母婴零售
          goodsId = '211'
          break
        case 8:
          // 眼镜
          goodsId = '210'
          break
        case 10:
          // 轻餐饮
          goodsId = '209'
          break
        case 11:
          // 美业
          goodsId = '208'
          break
        case 12:
          // 宠物
          goodsId = '213'
          break
        case 15:
          // 旗舰版
          goodsId = '214'
          break
      }
      return goodsId
    },
    async receiveStatus () {
      let receiveStatus = await this.christmas.receiveStatus()
      if (receiveStatus === 'false') {
        this.ifGot = true
      } else {
        this.ifGot = false
      }
    },
    getCoupon: debounce(async function () {
      this.christmas.reveiveCoupon().then(res => {
        if (res === 'true') {
          this.$wejs.alert('优惠券领取成功')
          this.ifGot = false
        }
      }).catch(error => {
        console.log(error)
      })
    }, 220)
  },
  async mounted () {
    api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=217`)
    let res = await this.vasVersionInfo.getCurrentVersionInfo20191111()
    this.receiveStatus()
    this.version_params.version = res.Version
    this.version_params.industryId = res.industryId
  },
  events: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?a434aade